
import { BUSINESS_UNIT_EMAIL_CONTACT_METADATA } from './business-unit-email-contact.metadata';
import { BusinessUnitEmailContactBase } from './business-unit-email-contact.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface BusinessUnitEmailContact extends BusinessUnitEmailContactBase {
}

export interface BusinessUnitEmailContactTransient { }

export class BusinessUnitEmailContact extends CrudEntity<BusinessUnitEmailContact, number, BusinessUnitEmailContactTransient> implements BusinessUnitEmailContactTransient {
  constructor(source?: Partial<BusinessUnitEmailContact>, options?: CrudEntityConstructionOptions<BusinessUnitEmailContact, number, BusinessUnitEmailContactTransient>) {
    super(BUSINESS_UNIT_EMAIL_CONTACT_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





